<template>
    <div class="fill-height">
        <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark class="px-2">
            <v-btn icon :href="valzum" target="_blank">
                <v-icon large>mdi-wallet-bifold</v-icon>
            </v-btn>
            <v-spacer/>
            <v-toolbar-title>
                <v-img class="mx-3" src="/img/logo-light.png" max-height="50px" contain></v-img>
            </v-toolbar-title>
            <v-spacer/>
            <v-menu transition="scroll-x-transition" bottom left offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                        <v-avatar size="36">
                            <img :src="'/img/country/' + country + '.png'" :alt="country === null ? '' : country.toLowerCase()">
                        </v-avatar>
                    </v-btn>
                </template>
                <v-list class="list-custom">
                    <v-list-item v-for="(i, v) in countries" :key="v" @click="getCountry(i.code)" v-if="i.code !== country">
                        <v-list-item-avatar>
                            <img :src="'/img/country/'+i.code+'.png'" :title="i.name" :alt="i.name.toLowerCase()" />
                        </v-list-item-avatar>
                        <v-list-item-title>{{ i.name }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-main>
            <transition name="fade" mode="out-in">
                <router-view
                    :country="country"
                    :items="items"
                    :item="item"
                    :rates="rates"
                    :load="loading"
                />
            </transition>
        </v-main>
        <v-bottom-navigation app grow fixed dark background-color="primary">
            <v-btn class="px-1" to="/">
                <span>Inicio</span>
                <v-icon>mdi-home</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/calculator">
                <span>Calculadora</span>
                <v-icon>mdi-calculator</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/history">
                <span>Histórico</span>
                <v-icon>mdi-clock</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/settings">
                <span>Configuración</span>
                <v-icon>mdi-cog</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </div>
</template>

<script>
    import Form from '../helpers/form';
    import { getUA, isIOS, isAndroid } from 'mobile-device-detect';
    import axios from "axios";

    export default {
        name: "DefaultComponent",
        mixins: [ Form ],
        data: () => ({
            loading: true,
            useragent: getUA,
            iOS: isIOS,
            Android: isAndroid,
            country: null,
            countries: [
                { name: 'Colombia', code: 'COL' },
                { name: 'Venezuela', code: 'VEN' }
            ],
            items: [],
            item: {},
            rates: []
        }),
        mounted() {
            this.getData(1);
            window.addEventListener('dollar-settings-changed', this.handleSettingsChanged);
        },
        computed: {
            valzum() {
                if (isIOS) {
                    return 'https://apps.apple.com/co/app/valzum-billetera-digital/id6751819427';
                } else if (isAndroid) {
                    return 'https://play.google.com/store/apps/details?id=com.valzum.app';
                } else {
                    return 'https://web.valzum.com/';
                }
            }
        },
        methods: {
            getData(v) {
                clearTimeout(this.timeout);
                if (v === 1) {
                    this.loading = true;
                }
                if (localStorage.country) {
                    this.country = localStorage.country;
                } else {
                    localStorage.country = 'COL';
                    this.country = 'COL';
                }
                axios.get('/api/info', { params: { country: this.country } }).then((res) => {
                    this.items = res.data.items;
                    this.item = res.data.item;
                    this.rates = res.data.rates || [];
                    this.notifyDailyRate();
                }).catch(err => {
                    this.handleErrors(err.response && err.response.data ? err.response.data.errors : null);
                }).then(() => {
                    this.loading = false;
                });
                this.scheduleRefresh();
            },
            getCountry(c) {
                localStorage.country = c;
                this.country = c;
                this.getData(1);
            },
            scheduleRefresh() {
                clearTimeout(this.timeout);

                if (localStorage.sync === 'false') {
                    return;
                }

                this.timeout = setTimeout(() => this.getData(), 28800000);
            },
            handleSettingsChanged() {
                if (localStorage.sync === 'false') {
                    clearTimeout(this.timeout);
                    return;
                }

                this.scheduleRefresh();
            },
            notifyDailyRate() {
                if (localStorage.notifications === 'false' || !('Notification' in window) || Notification.permission !== 'granted') {
                    return;
                }

                const today = new Date().toISOString().slice(0, 10);
                const key = 'dollar.notification.' + this.country + '.' + today;

                if (localStorage.getItem(key)) {
                    return;
                }

                const title = this.country === 'VEN' ? 'Dolar al Dia Venezuela' : 'Dolar al Dia Colombia';
                const digital = (this.rates || []).find(rate => rate.key === 'digital-usd');
                const official = (this.rates || []).find(rate => rate.key === 'bcv-usd');
                const body = this.country === 'VEN'
                    ? 'Digital: ' + this.formatRate(digital) + ' | Oficial BCV: ' + this.formatRate(official)
                    : 'TRM: $' + Number(this.item.today || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' COP';

                localStorage.setItem(key, '1');
                new Notification(title, { body });
            },
            formatRate(rate) {
                if (!rate) {
                    return 'No disponible';
                }

                return rate.symbol + Number(rate.value || 0).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }) + ' ' + rate.to;
            }
        },
        destroyed() {
            clearTimeout(this.timeout);
            window.removeEventListener('dollar-settings-changed', this.handleSettingsChanged);
        }
    }
</script>

<style scoped>
.list-custom{
    min-height: 48px;
    max-height: 448px;
    overflow-y: auto;
    padding: 0;
}
.v-item-group.v-bottom-navigation .v-btn {
    min-width: 64px;
}
</style>
